import cn from 'classnames';
import React, { FC, memo, useMemo } from 'react';

import Typography from '@mui/material/Typography';

import { useAuth } from '@contexts/common/AuthorizationContext';

import Button, { ButtonProps } from '@components/common/Button';

import {
  AVAILABLE_CHAINS_LIST,
  CHAIN_INFO,
  DEFAULT_CHAIN_ID,
} from '@constants/common/chain.constants';
import { Size, Variant } from '@constants/common/ui.constants';

import { ChainInfo } from '@app-types/common/token.types';

import useStyles from './styles.module';

interface Props extends ButtonProps {
  className?: string;
  isActive?: boolean;
  hideChainName?: boolean;
  size?: Size;
}

const ChainButton: FC<Props> = ({
  className = '',
  isActive = false,
  hideChainName = true,
  size = Size.Medium,
  onClick = undefined,
  ...props
}) => {
  const { classes } = useStyles();

  const { chainId } = useAuth();

  const chainInfo: ChainInfo = useMemo(
    () => CHAIN_INFO[chainId || DEFAULT_CHAIN_ID],
    [chainId],
  );

  const isNotSupportedChain = useMemo(() => {
    if (!chainId) return false;

    return !AVAILABLE_CHAINS_LIST.includes(chainId);
  }, [chainId]);
  return (
    <Button
      className={cn(classes.btn, { [classes.activeBtn]: isActive }, className)}
      onClick={onClick}
      variant={Variant.Secondary}
      size={size || Size.Medium}
      startIcon={
        !isNotSupportedChain && (
          <span className={classes.chainIcon}>
            <img src={chainInfo?.logo} alt="" className={classes.logo} />
          </span>
        )
      }
      fullWidth
      {...props}
    >
      {isNotSupportedChain ? (
        'Wrong Network'
      ) : (
        <span className={cn({ [classes.chainWithName]: !hideChainName })}>
          {!hideChainName && (
            <Typography variant="subtitle1">{chainInfo?.name}</Typography>
          )}
        </span>
      )}
    </Button>
  );
};

export default memo(ChainButton);
